import parse, { domToReact } from 'html-react-parser';
import { Box } from '@mui/material';
import sanitizeHtml from 'sanitize-html';


const AbstractCleanupComponent = ({ mainText, onLinkClick }) => {
  const transform = (node, index) => {
    // Remove any script tags
    if (node.type === 'script') {
      return null;
    }

    // Only process <a> tags
    if (node.type === 'tag' && node.name === 'a') {
      return (
        <Box
          key={index}
          component="a"
          href={node.attribs.href}
          target="_blank"
          onClick={(e) => {
            e.preventDefault();
            onLinkClick();
            window.open(node.attribs.href, '_blank');
          }}
        >
          {domToReact(node.children, { replace: transform })}
        </Box>
      );
    }

    // Process text nodes to replace plain text URLs with <a> tags
    if (node.type === 'text') {
      return node.data;
    }

    return domToReact(node.children, { replace: transform });
  };

  // First, let's escape all angle brackets
  const escapedText = mainText.replace(/</g, '&lt;').replace(/>/g, '&gt;');

  // Then, let's unescape only legitimate <a> tags
  const unescapeAnchorTags = (text) => {
    // Pattern for escaped anchor tags
    const pattern = /&lt;a\s+href=['"]([^'"]+)['"][^&]*&gt;(.*?)&lt;\/a&gt;/gi;
    return text.replace(pattern, '<a href="$1">$2</a>');
  };

  const processedText = unescapeAnchorTags(escapedText);

  let comp: string | React.JSX.Element | React.JSX.Element[] = '';

  try {
    comp = parse(sanitizeHtml(processedText, {
      allowedTags: ['a'],
      allowedAttributes: {
        'a': ['href']
      }
    }), { replace: transform });
  } catch (error) {
    comp = processedText; // Use the pre-processed text in case of error
    console.warn(error);
  }

  return <>{comp}</>;
};

export default AbstractCleanupComponent;

